import cityReducer from './city-reducer';

export default cityReducer;
